import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
export function Difference() {
  return <section className="w-full bg-background px-5 py-20 sm:py-28" data-id="element-43" data-mp="e3n6tdlsvhuo">
      <div className="mx-auto max-w-5xl" data-id="element-44" data-mp="9cslq7fj62v">
        <div className="mx-auto max-w-3xl text-center" data-id="element-45" data-mp="598wlpg4mxif">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-secondary" data-id="element-46" data-mp="57xq3hvarbnm">
            Un modo migliore di insegnare matematica
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-foreground sm:text-5xl" data-id="element-47" data-mp="3rgp880snzbgo">
            Da Docente Sopraffatto a{' '}
            <span className="italic text-primary" data-id="element-48" data-mp="3ifr6jp5p7g19">Guida Sicura.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-foreground/60 sm:text-base" data-id="element-49" data-mp="3ihlr32d2564t">
            Matematica Pronta trasforma ore di pianificazione estenuante in un
            sistema «apri e insegna». Entra in ogni lezione con un piano chiaro,
            attività visuali già pronte e la sicurezza di chi ha già tutto sotto
            controllo.
          </p>
        </div>

        <div className="mt-14 overflow-hidden rounded-3xl bg-surface shadow-card" data-id="element-50" data-mp="1f7hbngl9rvn0">
          <div className="grid md:grid-cols-2" data-id="element-51" data-mp="1t0715v00biov">
            <div className="relative bg-muted p-8 sm:p-10" data-id="element-52" data-mp="1o1dno2kpzrop">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-surface text-foreground/35" data-id="element-53" data-mp="1o3yqouwr8do1">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-54" data-mp="wbhl8a7xx05j" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-foreground/40" data-id="element-55" data-mp="1ab0g41bqqezw">
                Il costo di partire da zero ogni giorno
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-foreground" data-id="element-56" data-mp="2lpnoie8rs9e8">
                IL VECCHIO MODO
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-foreground/55" data-id="element-57" data-mp="2gq1gqkbpnlct">
                Stancante, improvvisato, mai finito.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-58" data-mp="2ssazig7wnjmt">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-surface/80 px-4 py-3 text-sm text-foreground/60" data-id="element-59" data-mp="2xrxg8zmxzi0d">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-foreground/30" aria-hidden="true" data-id="element-60" data-mp="32ra3hlhq6r3h" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-surface p-8 sm:p-10" data-id="element-61" data-mp="2a1kyyy5t48x4">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-secondary text-surface" data-id="element-62" data-mp="2a002h2zxmfwm">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-63" data-mp="2jsfpieq35uod" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-secondary" data-id="element-64" data-mp="1mdjuc0br1cmz">
                Il sistema Matematica Pronta
              </span>
              <h3 className="mt-3 max-w-[16rem] font-display text-2xl font-bold tracking-wide text-foreground" data-id="element-65" data-mp="1r9ihjklccolt">
                CON MATEMATICA PRONTA
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-foreground/55" data-id="element-66" data-mp="1etskey9jsdk7">
                La tua nuova realtà.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-67" data-mp="14vbmfhc6yyon">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-subtle px-4 py-3 text-sm font-medium text-foreground" data-id="element-68" data-mp="14x5vnye3p2cw">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-secondary" aria-hidden="true" data-id="element-69" data-mp="w282cq71jnl1" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-foreground/5 bg-background px-6 py-4 text-center text-xs text-foreground/50" data-id="element-70" data-mp="m5d4m9ildr7t">
            Un sistema completo per pianificare meno e insegnare con più senso.
          </p>
        </div>
      </div>
    </section>;
}